import { render, staticRenderFns } from "./ApiFailureLogs.vue?vue&type=template&id=50451898&scoped=true&"
import script from "./ApiFailureLogs.vue?vue&type=script&lang=js&"
export * from "./ApiFailureLogs.vue?vue&type=script&lang=js&"
import style0 from "./ApiFailureLogs.vue?vue&type=style&index=0&id=50451898&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50451898",
  null
  
)

export default component.exports